import { ClassRow, ReportSummaryRow } from './reports-model';

export class ClubCentricClassItem extends ClassRow {
    instructor: string;
    instructorId: string;
}

export class ClubCentricClubSummaryItem extends ReportSummaryRow {
    totalHours: number;
    totalCost: number;
    classes: ClubCentricClassItem[];

    constructor(public clubId: string, public clubName: string, public clubShortName: string) {
        super();
        this.clubId = clubId;
        this.clubName = clubName;
        this.clubShortName = clubShortName;
        this.totalCost = 0;
        this.totalHours = 0;
        this.classes = new Array<ClubCentricClassItem>();
    }
}

export class ClubCentricFilters {
    constructor(public className: string, public instructors: string[]) {}
}
